module.exports = __webpack_public_path__ + "img/1.1abd6e95.png";